export const SSO_EXTERNAL_ID_COLUMN = 'SSO external ID';
export const SP_STATUS_COLUMN = 'SP';

export const BASE_COLUMNS = {
    USER_NAME: 'User name',
    EMAIL: 'Email',
} as const;

export const COMMON_COLUMNS = {
    FIRST_NAME: 'First name',
    MIDDLE_NAME: 'Middle name',
    LAST_NAME: 'Last name',
    USER_NUMBER: 'User number',
    PASSWORD: 'Password',
    ORGANIZATION_NAMES: 'Organization names',
    ROLE: 'Role',
} as const;

export const DEMOGRAPHIC_COLUMNS = {
    DATE_OF_BIRTH: 'Date of birth',
    GENDER: 'Gender',
    PRONOUNS: 'Pronouns',
    RACE: 'Race',
    ETHNICITY: 'Ethnicity',
    COUNTRY: 'Country',
    CITY: 'City',
    STATE: 'State',
    POSTAL_CODE: 'Postal code',
    PHONE: 'Phone',
    LANGUAGES_SPOKEN: 'Languages spoken',
    EDUCATION: 'Education',
    CITIZENSHIP_WORKING_STATUS: 'Citizenship / Working status',
    WEIGHT_RANGE: 'Weight range',
    HEIGHT_RANGE: 'Height range',
    TATTOO: 'Tattoo',
    SCAR: 'Scar',
    EMPLOYEE: 'Employee',
    STUDENT: 'Student',
    SP_EXPERIENCE: 'SP experience',
    NOTES: 'Notes',
} as const;

export const IMPORT_ACTIONS = {
    UPSERT_USERS: 'UPSERT_USERS',
    UPSERT_USERS_WITH_SP_STATUS: 'UPSERT_USERS_WITH_SP_STATUS',
    ENABLE_SP_STATUS: 'ENABLE_SP_STATUS',
    NONE: 'NONE',
} as const;